import React from 'react';
import { View, Text, Image, TouchableWithoutFeedback, Dimensions } from 'react-native';
// import {deviceHeight, 480} from './../Utils';
// import Icons from 'react-native-vector-icons/FontAwesome';
import moment from 'moment'
const home_bg = require('./../../assets/home_bg.png');
const BreadCrumb = require('./../../assets/breadCrumb/menu.png');
const analog_rect_logo = require('./../../assets/analog_rect_logo.png');
const { width, height } = Dimensions.get("window");


const greet = () => {
  const hr = moment().hour();
  if (hr >= 0 && hr < 12) {
      return "Good Morning..!"
  } else if (hr >= 12 && hr <= 17) {
      return "Good Afternoon..!"
  } else {
      return "Good Evening..!"
  }
}

export default ({user,navigation}) => {
    return(
        <View style={{
            // backgroundColor: '#f1767a',
            width: width <= 780 ?  width : '100%',
            height: width <= 780 ? 260 : 600,
            // position: 'relative',
            // borderWidth: 2
          }}>
            <Image 
              source={home_bg}
              style={{
                width:  width <= 780 ?  width : '100%',
                height:  width <= 780 ? 260 : 600,
                marginLeft: width <= 780 ? 0 : -22
              }} 
              // resizeMode="contain"
            /> 
           <View
            style={{
              position: 'absolute',
              right: 10,
              bottom: width <= 780  ? 15 : 80,
              // width: width <= 780  ? (width / 2) - 20 : 0,
              // height: 90,
              // borderWidth: 1
            }}
           >
             <Text style={{color: 'red', fontSize: 10, fontWeight: '700', alignSelf: 'flex-end', marginRight: 15}}>Online E-learning</Text>
           <Image 
              source={analog_rect_logo}
              style={{
                width: width <= 780  ? (width / 2) - 20 : (600/2) - 10,
                height: width <= 780  ? 50 : 80,                                              
              }}
              resizeMode={`${width <= 780  ? 'contain'  : 'cover'}`}
            />
           </View>
           <View
            style={{
              position: 'absolute',
              top: 20,
              left: 20
            }}
           >
             {/* <TouchableWithoutFeedback
              //  onPress={navigation.openDrawer}
               style={{marginTop: 20}}
               hitSlop={{
                 top: 8,
                 bottom: 8,
                 left: 8,
                 right: 8
               }}
             >
               <View
               
               >
               <Image
                source={BreadCrumb}
              //  name={'bars'} 
                //  size={24}
                style={{width: 24, height: 24}}/>
               </View>
             </TouchableWithoutFeedback> */}
             </View>
           <View
            style={{
              position: 'absolute',
              top: 65,
              left: 20
            }}
           >
           
             <Text style={{fontSize: 20, color: '#000', fontWeight: '700', marginBottom: 2}}>Welcome</Text>
            <Text style={{fontSize: 12, color: '#fff', fontWeight: '500'}}>{greet()}, {user}</Text>
           </View>
          </View>
    )
}
